import React from "react";
import AutoBindComponent from "./AutoBindComponent";

/*
 Handleiding:
    In de page die extended is door ScrollToFirstErrorComponent volgende aanpassingen doorvoeren:
        - componentDidUpdate() -> call naar 'super.componentDidUpdate();' indien de componentDidUpdate() geimplementeerd is
        - in de then na het saven -> this.context.setState({ shouldScrollToFirstError: true });
*/

class ScrollToFirstErrorComponent extends AutoBindComponent {
   constructor(props, context, checkUnsavedChanges) {
        super(props, context, checkUnsavedChanges);

        this.state = {
            shouldScrollToFirstError: true
        };
    }

    componentDidUpdate() {
        if (this.state.shouldScrollToFirstError) {
            const elementsWithErrorClassname = Array.from(document.getElementsByClassName('validationmessage')).filter(x => x.innerHTML.trim().length > 0);

            if (elementsWithErrorClassname.length > 0) {
                let offsetTopOfFirstError = elementsWithErrorClassname[0].offsetTop;
                let headerHeight = 0;
                let navigationHeight = 0;

                const headerElements = window.parent.document.getElementsByClassName('c-header');
                if (headerElements.length > 0) {
                    headerHeight = headerElements[0].offsetHeight;

                    const navigationElements = window.parent.document.getElementsByClassName('c-navigation');
                    if (navigationElements.length > 0)
                        navigationHeight = navigationElements[0].offsetHeight;
                }
                offsetTopOfFirstError = offsetTopOfFirstError + headerHeight + navigationHeight;

                const screenSize = window.parent.innerHeight;
                offsetTopOfFirstError = offsetTopOfFirstError - (screenSize / 2);
                if (offsetTopOfFirstError < 0)
                    offsetTopOfFirstError = 0;

                window.parent.scrollTo(0, offsetTopOfFirstError);
            }

            this.updateState();
        }
    }

    updateState() {
        this.setState({
            shouldScrollToFirstError: false
        });
    }
}

export default ScrollToFirstErrorComponent;